import { SELECT_LANG } from '../mutation-types';
// import * as _ from '@reolink-web/utils';
import { config } from 'CONFIG';
import { lang, LANG_KEY } from '@/lang/reolink';

interface ILangState {
    lang: string;
}

const state = {

    lang

};

const mutations = {

    [ SELECT_LANG ]( state: ILangState, lang: string ): void {

        state.lang = lang;

        const date = new Date();
        date.setTime( date.getTime() + 86400 * 1000 * 365 );

        document.cookie = LANG_KEY + '=' + lang + '; path=/; domain=' + config.cookieDomain + '; expires=' + date.toString();

    }

};

const getters = {

    lang: ( state: ILangState ): string => state.lang

};

export default {

    state,
    mutations,
    getters

};
